import { Plugins } from '@leverege/plugin';
import BooleanValidator from "./BooleanValidator.js";
import TimestampValidator from "./TimestampValidator.js";
import StringValidator from "./StringValidator.js";
import GeoPointValidator from "./GeoPointValidator.js";
import UnitValidator from "./UnitValidator.js";
import IntArrayValidator from "./IntArrayValidator.js";
import IntValidator from "./IntValidator.js";
import NumberValidator from "./NumberValidator.js";
import NumberArrayValidator from "./NumberArrayValidator.js";
import StringArrayValidator from "./StringArrayValidator.js";
export default {
  install(plg = Plugins) {
    plg.addPlugin('AttributeValueValidator', BooleanValidator);
    plg.addPlugin('AttributeValueValidator', GeoPointValidator);
    plg.addPlugin('AttributeValueValidator', IntArrayValidator);
    plg.addPlugin('AttributeValueValidator', IntValidator);
    plg.addPlugin('AttributeValueValidator', NumberArrayValidator);
    plg.addPlugin('AttributeValueValidator', NumberValidator);
    plg.addPlugin('AttributeValueValidator', StringArrayValidator);
    plg.addPlugin('AttributeValueValidator', StringValidator);
    plg.addPlugin('AttributeValueValidator', TimestampValidator);
    UnitValidator.install(plg);
  }
};